export class ReportAnnualDegreeImprovement {

    /**
     *
     * @param values
     */
    constructor(values = null) {
        this.title = values?.title || '';

        this.academic_period = values?.academic_period || '';

        this.programs = values?.programs || [];

        this.report_type = values?.report_type || '';

        this.data_sources = values?.data_sources || [];
    }

    /**
     *
     * @returns {ReportAnnualDegreeImprovement}
     */
    static build(values) {
        return new ReportAnnualDegreeImprovement(values);
    }
}
